<template>
    <panel
        :noTitle="true"
        :variant="panelVariant"
        bodyClass=""
        noButton="true"
        class="facility-map-container"
        :style="{ backgroundColor: setBackgroundColor }"
    >
        <!-- ServerPopup 컴포넌트를 server 타입일 때 보여줌 -->
        <div v-if="parentData && parentData.data && parentData.data.type === 'server'" class="server-container">
            <server-popup
                :server="parentData.data"
                :childrens="parentData.children ? parentData.children.length : 0"
                :childrenData="parentData"
                mode="panel"
                @save-done="onServerSaveDone"
                @refresh-data="refreshData"
            />
        </div>

        <!-- ChannelPopup 컴포넌트를 channel 타입일 때 보여줌 -->
        <div v-else-if="parentData && parentData.data && parentData.data.type === 'channel'" class="channel-container">
            <channel-popup
                :serverIdx="parentData.data.serverIdx"
                :channelIdx="parentData.data.channelIdx"
                :childrens="parentData.children ? parentData.children.length : 0"
                :childData="parentData"
                mode="panel"
                @save-done="onChannelSaveDone"
                @refresh-data="refreshData"
            />
        </div>
        <!-- 선택한 노드가 계측기 이거나 부하일때 보여줌 -->
        <div
            v-else-if="parentData && parentData.data && parentData.data.type === 'facility'"
            class="facility-popup-container"
        >
            <FacilityPopup
                :serverIdx="facility?.serverIdx"
                :channelIdx="facility?.channelIdx"
                :parentFacilityIdx="facility?.parentFacilityIdx"
                :facilityIdx="facility?.facilityIdx"
                :channelType="facility?.channelType"
                :childrens="facility?.childrens"
                :subFacilityList="facility?.subFacilityList"
                :newCT="facility?.ct"
                :type="facility?.type"
                :hierarchy="hierarchy"
                :parentData="parentData"
                mode="panel"
                @save-done="onFacilityPopupSaveDone"
            />
        </div>
        <div v-else-if="parentData && parentData.data && parentData.data.type === 'subFacility'">
            <SubFacilityDetail
                :facilityIdx="parentData.data.facilityIdx"
                :facility="parentData.data"
                :hierarchy="hierarchy"
                :channelType="channel?.channelType || ''"
                :parentFacilityIdx="parentData.data.parentFacilityIdx"
                :parentFacilityName="option.parent.facilityName"
                @save-done="onSubFacilitySaveDone"
            />
        </div>
        <!-- 최상위 네트워크 구조일 때 NetworkOverview 컴포넌트 표시 -->
        <div v-else class="network-overview-container">
            <NetworkOverview :parentData="parentData" />
        </div>
    </panel>
</template>

<script>
import ServerPopup from "./ServerPopup.vue";
import ChannelPopup from "./ChannelPopup.vue";
import FacilityPopup from "./FacilityPopup.vue";
import NetworkOverview from "./NetworkOverview.vue";
import * as rules from "@src/consts/ruleConsts.js";
import * as popupMessages from "@src/consts/popupMessageConsts";
import SubFacilityDetail from "./SubFacilityDetail.vue";

export default {
    props: ["option", "parentData"], // TODO: save-done 부모에서 사용하지 않음..
    components: {
        ServerPopup,
        ChannelPopup,
        FacilityPopup,
        NetworkOverview,
        SubFacilityDetail,
    },
    data() {
        return {
            rules,
            popupMessages,
        };
    },
    computed: {
        isTopLevelNetwork() {
            return (
                this.parentData && this.parentData.data && this.parentData.data.type === "" && !this.parentData.parent
            );
        },

        setBackgroundColor() {
            return this.parentData &&
                this.parentData.data &&
                (this.parentData.data.type === "server" || this.parentData.data.type === "channel")
                ? "#d9e0e7 !important"
                : "";
        },

        facility() {
            return this.option.facility || null;
        },
        hierarchy() {
            if (this.server && this.channel && this.parent)
                return `${this.server.serverName} / ${this.channel.channelName} / ${this.parent.facilityName}`;
            if (this.server && this.channel) return `${this.server.serverName} / ${this.channel.channelName}`;
            return "";
        },
        server() {
            return this.option.server || null;
        },
        channel() {
            return this.option.channel || null;
        },
        parent() {
            return this.option.parent || null;
        },
    },
    watch: {},
    mounted() {},
    methods: {
        onSubFacilitySaveDone() {
            // 부모 컴포넌트에 서브모듈 저장 완료 이벤트 전달
            this.$emit("subFacility-save-done");
        },

        refreshData() {
            this.$emit("refresh-tree-data");
        },
        // ServerPopup에서 서버 저장 완료 시 호출되는 메서드
        onServerSaveDone() {
            // 부모 컴포넌트에 서버 저장 완료 이벤트 전달
            this.$emit("server-save-done");
        },

        // ChannelPopup에서 채널 저장 완료 시 호출되는 메서드
        onChannelSaveDone() {
            // 부모 컴포넌트에 채널 저장 완료 이벤트 전달
            this.$emit("channel-save-done");
        },

        // FacilityPopup에서 저장 완료 시 호출되는 메서드
        onFacilityPopupSaveDone() {
            // 부모 컴포넌트에 저장 완료 이벤트 전달
            this.$emit("facility-save-done");
        },
    },
};
</script>

<style scoped>
.server-container {
    height: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
}

.channel-container {
    height: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
}

.checkbox.checkbox-css input {
    display: block;
}

:not(.panel-body) {
    overflow-y: auto;
    overflow-x: hidden;
}
.facility-popup-container {
    height: 100%;
}

.network-overview-container {
    height: 100%;
}
</style>
